import React from "react";
import styled from "styled-components";

const PreviewContentTabContainer = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 22px;
    flex: 1;
    height: 56px;
    color: #ffffff;
    z-index: 5;
    top: 0;
    max-height: 34px;
  `;

  const PreviewContentTab = styled("div")`
    border-bottom: ${(props) => (props.active ? "2px solid #00B8B8" : "none")};
    cursor: pointer;
    margin: 0 0.25rem;
  `;

  const PreviewContentTabText = styled("div")`
    padding: 0.5rem 0.125rem;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 130%;
    text-align: center;
    color: #ffffff;
  `;

export default function InbioNavigation({ pages, setNavigation }) {
  function getInbioPreviewTab(page) {
    return (
      <PreviewContentTab
        key={page.id}
        active={page.active}
        onClick={() => setNavigation(page)}
      >
        <PreviewContentTabText>{page.title}</PreviewContentTabText>
      </PreviewContentTab>
    );
  }

  return (
    <PreviewContentTabContainer>
      {pages.map((page) => {
        return getInbioPreviewTab(page);
      })}
    </PreviewContentTabContainer>
  );
}
